module.exports = "https://static.wmbcdn.com/uniweb/images/f4a057dd4243f92878df085b025da5d2.svg";